<template>
  <div>
    <div v-if="!returnReplacementReceiptAcknowledgmentEnabled">
      Return Replacement Acknowledgement (Signature) is not required for this transaction... Please Continue..


    </div>
    <div v-else>
      <tool-tip style="float: right;" v-on:updateToolTip="updateToolTip($event)" v-if="replace_lsss_tooltip_name"
        :name="replace_lsss_tooltip_name" :description="replace_lsss_tooltip_description" :editable="editable"></tool-tip>

      <div class="row justify-content-left more-bottom-padding">
        <div class="col-md-6">
          <label>Partial or Completed Delivery of Replacement LSSS</label><br />
          <input :disabled="(!isLegacyOrder && isReturned) || isReadOnly || checkForPartnerNationCondition || isReturned"
            v-validate="'required'" name="partialReturnCompleted" data-vv-as="Delivery of Replacement LSSS" type="radio"
            id="PartialRadio" :value="true" v-model="returnReplacementReceiptAcknowledgment.isPartialReturn" />
          <label for="PartialRadio" class="ml-1">Partial</label>
          <br />
          <input :disabled="(!isLegacyOrder && isReturned) || isReadOnly || checkForPartnerNationCondition || isReturned"
            v-validate="'required'" name="partialReturnCompleted" data-vv-as="Delivery of Replacement LSSS" type="radio"
            id="CompleteRadio" :value="false" v-model="returnReplacementReceiptAcknowledgment.isPartialReturn" />
          <label for="CompleteRadio" class="ml-1"> Complete</label>
          <br>
          <span v-show="errors.has('partialReturnCompleted')" class="error">{{ errors.first("partialReturnCompleted") }}
          </span>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-sm-6 more-top-padding">
          <base-input label="Delivered Return / Replacement to Unit">
            <base-input :disabled="isReadOnly || checkForPartnerNationCondition || isReturned" v-model="returnReplacementReceiptAcknowledgment.deliveryReturnUnit
              " name="deliverReturnReplacementToUnit" v-validate="'required|max:300'"
              data-vv-as="Delivered Return / Replacement to Unit" :error="getError('deliverReturnReplacementToUnit')">
            </base-input>
          </base-input>
        </div>
        <div class="col-sm-6 more-top-padding">
          <base-input label="Delivered to Unit Address or Location">
            <base-input :disabled="isReadOnly || checkForPartnerNationCondition || isReturned" v-model="returnReplacementReceiptAcknowledgment.deliveryReturnPlace
              " name="deliverToUnitAddressOrLocation" v-validate="'required|max:500'"
              data-vv-as="Delivered to Unit Address or Location" :error="getError('deliverToUnitAddressOrLocation')">
            </base-input>
          </base-input>
        </div>
        <div class="col-sm-12 more-top-padding">
          <label>Delivered to Country</label>
          <v-select :disabled="isReadOnly || checkForPartnerNationCondition || isReturned"
            v-model="returnReplacementReceiptAcknowledgment.deliveryReturnCountryId"
            :reduce="(country) => country.countryId" label="name" :options="allCountries" name="deliverToCountryId"
            placeholder="Select an option" data-vv-as="Delivered to Country"
            :class="errors.has('deliverToCountryId') ? 'has-danger' : ''" v-validate="'required'"
            :error="getError('deliverToCountryId')"></v-select>
          <span v-show="errors.has('deliverToCountryId')" class="error">{{ errors.first("deliverToCountryId") }}
          </span>
        </div>
      </div>

      <hr class="solid" />

      <div class="row justify-content-center">
        <div class="col-sm-6 more-top-padding">
          <base-input label=" Name (Last, First, MI, Rank / Title)">
            <base-input :disabled="isReadOnly || checkForPartnerNationCondition || isReturned" v-model="returnReplacementReceiptAcknowledgment.returnSignerName
              " name="inspectedReceivedByName" data-vv-as="Name" v-validate="'required|max:300'"
              :error="getError('inspectedReceivedByName')">
            </base-input>
          </base-input>
        </div>
        <div class="col-sm-6 more-top-padding">
          <base-input label="Unit / Office">
            <base-input :disabled="isReadOnly || checkForPartnerNationCondition || isReturned" v-model="returnReplacementReceiptAcknowledgment.returnUnitOffice
              " name="inspectedReceivedByUnitOffice" data-vv-as="Unit / Office" v-validate="'required|max:300'"
              :error="getError('inspectedReceivedByUnitOffice')">
            </base-input>
          </base-input>
        </div>
        <div class="col-sm-6 more-top-padding">
          <label>Nation / Organization</label>

          <v-select :disabled="isReadOnly || checkForPartnerNationCondition || isReturned"
            v-model="returnReplacementReceiptAcknowledgment.returnOrganizationId" :reduce="(org) => org.id" label="name"
            :options="returnReplacementReceiptAcknowledgment.organizations" placeholder="Select one"
            name="nationOrganization" data-vv-as="Nation/Organization"
            :class="errors.has('nationOrganization') ? 'has-danger' : ''" v-validate="'required'"
            :error="getError('nationOrganization')"></v-select>
          <span v-show="errors.has('nationOrganization')" class="error">{{ errors.first("nationOrganization") }}
          </span>
        </div>
        <div class="col-sm-6 more-top-padding">
          <!-- verify Pin Code -->
          <verify-pin v-if="isSigned" :checkForPartnerNationCondition="checkForPartnerNationCondition" :isPartnerAccount="isPartnerAccount"  :isReadOnly="isReadOnly" v-on:pinVerify="pinVerify"/>

          <AlertSignature ref="signatureImageRef" :headerText="' Return Replacement Acknowledgement Signature'"
            :module="'returnReplacementReceiptAcknowledgment'" :action="'getReturnReplacementReceiptAcknowledgment'"
            v-on:onUpload="fileUploaded" :isPinVerified="isPinVerificationDone"
            :activeTab="returnReplacementReceiptAcknowledgment.returnSignature.type" v-on:onSigned="onSigned"
            :signatureData="returnReplacementReceiptAcknowledgment.returnSignature" :fileTypeId="7"
            :textDisabled="checkForPartnerNationCondition || isReturned || isReadOnly"
            :drawDisabled="checkForPartnerNationCondition || isReturned || isReadOnly"
            :uploadDisabled="isPartnerAccount || isReturned || isReadOnly"
            :certificateDisabled="isPartnerAccount || isReturned || isReadOnly || !signedInWithCac" />

        
          <label style="margin-left: 5px; margin-right: 5px" v-if="isUsBuyOrder  && !isPartnerAccount">or</label>
          <request-signature 
            :signatureUrl="`api/replacementacknowlegments/request/${getOrderIdFromRoute}`"
            v-bind:moduleSubmit="submit"
            :requestDate="returnReplacementReceiptAcknowledgment.returnDateRequested"
            @update-status="updateStatus"
            :isDisabled="isRequestDisabled"
            v-if="isUsBuyOrder  && !isPartnerAccount">
          </request-signature>
          <notify-finance :signatureUrl="`/api/replacementacknowlegments/request/finance/${getOrderIdFromRoute}`"
            :notifyDate="returnReplacementReceiptAcknowledgment.notifyFinance"
            :isDisabled="isNotifyDisabled"
            @update-status="updateStatus" 
            v-if="!isPartnerAccount"></notify-finance> 

          <div v-if="hasSignatureImage()" class="container signature_content_padding_top_small signature_field">
            <div class="row justify-content-end">
              <delete-signature :headerText="'Are you sure you want to delete Return Signature?'"
                :signatureId="returnReplacementReceiptAcknowledgment.returnSignature.signatureId" 
                :fileTypeId="7"
                :signatureType="returnReplacementReceiptAcknowledgment.returnSignature.type" 
                :disabled="isPartnerAccount || isReturned"
                v-on:modal-closed="reloadData"></delete-signature>
            </div>

            <img class="image_layout" :src="returnReplacementReceiptAcknowledgment.returnSignature.view" height="100">
          </div>
          <div>
            <div class="less-top-padding">
              <label>Signature Date</label>
              <el-date-picker
                :disabled="(isReturned && !isLegacyOrder) || isReadOnly || isPartnerAccount || (!isRelevantDocumentUploaded && !fileUploadedBoolean)"
                v-model="returnReplacementReceiptAcknowledgment.returnDateSigned
                  " type="date" :editable="false" format="dd-MMMM-yyyy" data-vv-as="Signature Date" name="dateSigned"
                :class="errors.has('dateSigned') ? 'has-danger' : ''" :error="getError('dateSigned')">
              </el-date-picker>
              <span v-show="errors.has('dateSigned')" class="error">Signature Date is required
              </span>
            </div>
          </div>
        </div>
      </div>

      <hr class="solid" />

      <div class="row justify-content-center">
        <div class="col-sm-12 more-top-padding">
          <label>Replacement Schedule</label>
        </div>
        <div class="col-sm-6">
          <label>Initial Delivery Date</label>
          <el-date-picker  :disabled="isReadOnly || checkForPartnerNationCondition || isReturned" v-model="returnReplacementReceiptAcknowledgment.initialDeliverySchedule
            " type="date" :editable="false" format="dd-MMMM-yyyy" placeholder="Initial Delivery Date"
            :picker-options="initialDeliverySchedulePickerOptions" data-vv-as="Signature Date"
            name="initialDeliverySchedule" :class="errors.has('initialDeliverySchedule') ? 'has-danger' : ''"
            v-validate="'required'" :error="getError('initialDeliverySchedule') " value-format="yyyy-MM-dd">
          </el-date-picker>
          <span v-show="errors.has('initialDeliverySchedule')" class="error">Initial Delivery Date is required
          </span>
        </div>
        <div class="col-sm-6">
          <label>Return Delivery Date</label>
          <el-date-picker :disabled="isReadOnly || checkForPartnerNationCondition || isReturned" v-model="returnReplacementReceiptAcknowledgment.returnDeliverySchedule
            " type="date" :editable="false" format="dd-MMMM-yyyy" placeholder="Return Delivery Date"
            :picker-options="returnDeliverySchedulePickerOptions" data-vv-as="Signature Date"
            name="returnDeliverySchedule" :class="errors.has('returnDeliverySchedule') ? 'has-danger' : ''"
            v-validate="'required'" :error="getError('returnDeliverySchedule')" value-format="yyyy-MM-dd">
          </el-date-picker>
          <span v-show="errors.has('returnDeliverySchedule')" class="error">Return Delivery Date is required
          </span>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-sm-12 more-top-padding">
          <div class="pull-right">
            <base-button type="primary"
              :disabled="isReadOnly || isReturned || checkForPartnerNationCondition || isReturned" wide
              @click.native="submit" class="btn-next">Save</base-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AlertSignature from "@/components/App/signatures/AlertSignature.vue";
import RequestSignature from "@/components/App/signatures/RequestSignature.vue";
import DeleteSignature from "@/components/App/signatures/DeleteSignature.vue";
import NotifyFinance from "@/components/App/signatures/NotifyFinance.vue"
import VerifyPin from '@/components/App/order/VerifyPin.vue';
import { mapGetters, mapActions } from "vuex";
import { Button } from "element-ui";
import Util from "@/util/util";
import moment from "moment";
import toolTip from "../../Tooltip";
import { EventBus } from "@/event-bus.js";

export default {
  name: "ReturnReplacementReceiptAcknowledgment",
  props: ["isReadOnly"],
  created(){
    var ctx = this;
    EventBus.$on('finance-user-change', async (value)=>{
      await ctx.changeUserRefresh();
    });
    EventBus.$on('pn-user-change', async (value)=>{
      await ctx.changeUserRefresh();
    });
  },
  async mounted() {
    let ctx = this;

    await ctx.getAllTooltips()
    ctx.loadToolTips();
    EventBus.$on('doc-type-change', async() => {
      ctx.$loaderApp.addRequest();
      await ctx.getReturnReplacementReceiptAcknowledgmentStatus(ctx.$route.params.id);
      ctx.$loaderApp.completeRequest();
    });
  },
  data() {
    return {
      initialDeliverySchedulePickerOptions: {
        disabledDate: this.disabledInitialDeliverySchedule,
      },
      returnDeliverySchedulePickerOptions: {
        disabledDate: this.disabledReturnDeliverySchedule,
      },
      USCountryId: false,
      replace_lsss_tooltip_description: '',
      replace_lsss_tooltip_name: '',
      fileUploadedBoolean: false,
      isPinVerificationDone: false,
      pin: null,
      refreshKey: 0,
      sigHasSigned: false
    };
  },
  components: {
    AlertSignature,
    [Button.name]: Button,
    toolTip,
    RequestSignature,
    DeleteSignature,
    VerifyPin,
    NotifyFinance
  },

  computed: {
    ...mapGetters({
      allCountries: "countries/allCountries",
      returnReplacementReceiptAcknowledgment:
        "returnReplacementReceiptAcknowledgment/returnReplacementReceiptAcknowledgment",
      returnReplacementReceiptAcknowledgmentEnabled:
        "returnReplacementReceiptAcknowledgment/returnReplacementReceiptAcknowledgmentEnabled",
      returnReplacementReceiptAcknowledgmentHelper:
        "returnReplacementReceiptAcknowledgment/returnReplacementReceiptAcknowledgmentHelper",
      returnReplacementErrors:
        "returnReplacementReceiptAcknowledgment/returnReplacementErrors",
      documents: "documents/getDocuments",
      getUser: "authentication/getUser",
      orderMetadata: "orderMetadata/orderMetadata",
      financeUserId: "orderMetadata/financeUserId",
      isPartnerAccount: "authentication/isPartnerAccount",
      isRikOrEveOrder: "preOrderDetail/isRikOrEveOrder",
      isMonetaryOrder: "preOrderDetail/isMonetaryOrder",
      isUsBuyOrder: "preOrderDetail/isUsBuyOrder",
      isUsSellOrder: "preOrderDetail/isUsSellOrder",
      isReceived: "orderMetadata/isReceived",
      isReturned: "orderMetadata/isReturned",
      replacementItemEnabled: "replacementItem/replacementItemEnabled",
      replacementItems: "replacementItem/replacementItems",
      agreementInfoSelectedCountryId:
        "agreementInformation/agreementInfoSelectedCountryId",
      toolTips: "tooltip/tooltips",
      editable: "tooltip/editable"

    }),
    isSigned() {
      if(this.returnReplacementReceiptAcknowledgment.returnDateRequested){
        if(!this.returnReplacementReceiptAcknowledgment.returnSignature.signatureId){
          return true
        }else return false
      }else return false
    },
    isRequestDisabled() {
      this.refreshKey;
      return !this.returnReplacementReceiptAcknowledgment.deliveryReturnUnit || !this.returnReplacementReceiptAcknowledgment.deliveryReturnPlace
        || !this.returnReplacementReceiptAcknowledgment.deliveryReturnCountryId || !this.returnReplacementReceiptAcknowledgment.returnSignerName
        || !this.returnReplacementReceiptAcknowledgment.returnUnitOffice || !this.returnReplacementReceiptAcknowledgment.returnOrganizationId
        || !this.returnReplacementReceiptAcknowledgment.initialDeliverySchedule || !this.returnReplacementReceiptAcknowledgment.returnDeliverySchedule
        || this.returnReplacementReceiptAcknowledgment.returnDateRequested ? true : false || this.returnReplacementReceiptAcknowledgment.returnSignature.view ? true : false || !this.isReceived || this.isReadOnly
    },
    isNotifyDisabled() {
      this.refreshKey;
      return !this.returnReplacementReceiptAcknowledgment.deliveryReturnUnit || !this.returnReplacementReceiptAcknowledgment.deliveryReturnPlace
        || !this.returnReplacementReceiptAcknowledgment.deliveryReturnCountryId || !this.returnReplacementReceiptAcknowledgment.returnSignerName
        || !this.returnReplacementReceiptAcknowledgment.returnUnitOffice || !this.returnReplacementReceiptAcknowledgment.returnOrganizationId
        || !this.returnReplacementReceiptAcknowledgment.initialDeliverySchedule || !this.returnReplacementReceiptAcknowledgment.returnDeliverySchedule
        || this.returnReplacementReceiptAcknowledgment.notifyFinance ? true : false  || !this.isReceived || this.isReadOnly || !this.financeUserId === null
    },

    isLegacyOrder() {
      if (this.orderMetadata.createDate)
        return Util.isLegacyOrder(this.orderMetadata.createDate);
    },
    checkForPartnerNationCondition() {
      if (this.isPartnerAccount) {
        if (this.isUsBuyOrder && this.isRikOrEveOrder) {
          if (this.returnReplacementReceiptAcknowledgment.returnDateRequested == null) {
            return true;
          }
          return false;
        }
        else {
          return true;
        }
      } else {
        return false;
      }
    },

    getOrderIdFromRoute() {
      return parseInt(this.$route.params.id);
    },
    signedInWithCac() {
      return this.getUser.loginMethod == "CAC";
    },
    isPartial() {
      return this.returnReplacementReceiptAcknowledgment.isPartialReturn;
    },
    checkSignatureGraphicalChanged() {
      return this.returnReplacementReceiptAcknowledgment.returnSignature.view;
    },
    isRelevantDocumentUploaded() {
      if (this.documents && this.documents.length > 0) {
        return this.documents.some(document => {
          return document.fileTypeNames.some(doc => doc === Util.RETURN_REPLACEMENT);
        });
      }
      return false
    },
    signatureDateAddedWithSignatureOrDocumentUploaded() {
      return this.isRelevantDocumentUploaded || this.hasSignatureImage() || this.signedInWithCac;
    }
  },


  methods: {
    ...mapActions({
      getReplacementItems: "replacementItem/getReplacementItems",
      getReplacementItemEnabled: "replacementItem/getReplacementItemEnabled",
      getAllCountries: "countries/getAllCountries",
      loadReturnReplacementReceiptAcknowledgment:
        "returnReplacementReceiptAcknowledgment/getReturnReplacementReceiptAcknowledgment",
      getReturnReplacementReceiptAcknowledgmentStatus:
        "returnReplacementReceiptAcknowledgment/getReturnReplacementReceiptAcknowledgmentStatus",
      getReturnReplacementReceiptAcknowledgmentHelper:
        "returnReplacementReceiptAcknowledgment/getReturnReplacementReceiptAcknowledgmentHelper",
      getReturnReplacementReceiptAcknowledgmentEnabled:
        "returnReplacementReceiptAcknowledgment/getReturnReplacementReceiptAcknowledgmentEnabled",
      saveReturnReplacementReceiptAcknowledgment:
        "returnReplacementReceiptAcknowledgment/saveReturnReplacementReceiptAcknowledgment",
      getAllTooltips: "tooltip/getToolTips",
      getOrganizations: "returnReplacementReceiptAcknowledgment/getOrganizations",
      getReturnReplacementReceiptAcknowledgmentSigOnly: "returnReplacementReceiptAcknowledgment/getReturnReplacementReceiptAcknowledgmentSigOnly"
    }),
    async changeUserRefresh() {
      await this.loadReturnReplacementReceiptAcknowledgment(this.getOrderIdFromRoute);
      this.refreshKey++;
    },
    updateStatus() {
      var ctx = this;
      this.loaded().then(d => {ctx.refreshKey++;return;});
    },
    pinVerify(val, pin) {
      this.isPinVerificationDone = val;
      this.pin = pin;
    },
    getCountryId() {
      this.axios.get(`/api/countries/name/United States`).then((response) => {
        this.USCountryId = true
        return {
          response
        };
      });
    },
    loadToolTips() {
      const replaceLsssToolTip = this.toolTips.find(e => e.name === "ReturnReplacmentReceiptModule")
      if (replaceLsssToolTip.status) {

        this.replace_lsss_tooltip_description = replaceLsssToolTip.description ? replaceLsssToolTip.description : null
        this.replace_lsss_tooltip_name = replaceLsssToolTip.name ? replaceLsssToolTip.name : null
      }
      return
    },
    updateToolTip(updatedData) {
      this.loadToolTips()
    },
    async onSigned() {
      // complete the request
      this.sigHasSigned = true;
      await this.submit();
      // only pn user will use this
      this.pin = null;
    },

    async fileUploaded() {
      this.fileUploadedBoolean = true;
      await this.getReturnReplacementReceiptAcknowledgmentSigOnly(this.getOrderIdFromRoute);
      await this.submit();
      this.$loaderApp.completeRequest();
        },
    toggleIsPartial(action) {
      this.returnReplacementReceiptAcknowledgment.selectedIsPartial = action;
    },
    showDocumentTab() {
      this.$emit("show-document-tab");
      EventBus.$emit('clicked-from', 'RETURN REPLACEMENT')

    },
    disabledInitialDeliverySchedule(time) {
      let disabled = false;

      if (!Util.isNullOrEmpty(this.returnReplacementReceiptAcknowledgment.returnDeliverySchedule)) {
        const selectedTime = new moment(time.getTime());

        const maxStartDate = new moment(
          this.returnReplacementReceiptAcknowledgment.returnDeliverySchedule
        );

        if (selectedTime > maxStartDate) {
          disabled = true;
        }
      }

      return disabled;
    },
    disabledReturnDeliverySchedule(time) {
      let disabled = false;

      if (
        !Util.isNullOrEmpty(
          this.returnReplacementReceiptAcknowledgment.initialDeliverySchedule
        )
      ) {
        const selectedTime = new moment(time.getTime());

        const minEndDate = new moment(
          this.returnReplacementReceiptAcknowledgment.initialDeliverySchedule
        );

        if (selectedTime < minEndDate) {
          disabled = true;
        }
      }

      return disabled;
    },
    async loaded() {
      this.refreshKey++;
      const ctx = this;
      await ctx.getReturnReplacementReceiptAcknowledgmentEnabled(ctx.$route.params.id)
      if (ctx.returnReplacementReceiptAcknowledgmentEnabled) {
        await ctx
          .getReturnReplacementReceiptAcknowledgmentHelper(
            ctx.getOrderIdFromRoute
          )
        const params = {
          buySell:
            ctx.returnReplacementReceiptAcknowledgmentHelper.buySell,
          countryId:
            ctx.returnReplacementReceiptAcknowledgmentHelper.countryId,
          preOrderDetailStatus: ctx.preOrderStatus,
          agreementInformationStatus: ctx.agreementInformationStatus,
        };
        await ctx.getOrganizations(params);
        await ctx.getAllCountries();
        await ctx.loadReturnReplacementReceiptAcknowledgment(
          this.getOrderIdFromRoute
        );
        if ((!this.isLegacyOrder && this.isReturned) || this.isReadOnly || this.checkForPartnerNationCondition || this.isReturned) {
          await ctx.getReplacementItemEnabled(ctx.$route.params.id);//.then(() => {
          if (ctx.replacementItemEnabled) {
            await ctx.getReplacementItems(ctx.$route.params.id)//.then(d => {
            var isComplete = true;
            for (var i = 0; i < this.replacementItems.length; i++) {
              var item = this.replacementItems[i];
              if (item.receivedQuantity !== item.requestedQuantity) {
                isComplete = false;
                break;
              }
            }
            if (isComplete) {
              this.toggleIsPartial(false);
            } else {
              this.toggleIsPartial(true);
            }
          }
        }
        let signatureImageRef = ctx.$refs.signatureImageRef;
        if(signatureImageRef)
          signatureImageRef.innerHTML = "";

        if (ctx.returnReplacementReceiptAcknowledgment.returnSignature) {
          try {
            let result = Util.getSignatureImageFromDataString(ctx.returnReplacementReceiptAcknowledgment.returnSignature)
            let image = result;
            //signatureImageRef.appendChild(image);
          
          } catch(err) {
            console.log(err.stack); //not handelled
          };
        }
      }
    },
    onReturnReplacementReceiptAcknowledgmentSignatureGraphicalResult: function (
      signatureData
    ) {
      this.$store.dispatch(
        "returnReplacementReceiptAcknowledgment/setSignature",
        signatureData
      );
    },
    hasSignatureImage() {
      return !Util.isNullOrEmpty(this.returnReplacementReceiptAcknowledgment.returnSignature.view);
    },
    showReturnReplacementErrors(response) {
      this.$toast.error(response);
    },

    async reloadData() {
      await this.getReturnReplacementReceiptAcknowledgmentStatus(this.getOrderIdFromRoute);
      await this.loadReturnReplacementReceiptAcknowledgment(this.getOrderIdFromRoute);
    },
    async submit(e) {
      this.$loaderApp.addRequest();
      let result = this.$validator.validateAll();
      if (result) {
        if (!this.signatureDateAddedWithSignatureOrDocumentUploaded && this.returnReplacementReceiptAcknowledgment.returnDateSigned) {
          this.returnReplacementReceiptAcknowledgment.returnDateSigned = null;
          this.$toast.error(Util.SIGNATURE_DATE_ADDED_WITHOUT_SIGNATURE_OR_DOCUMENT_UPLOADED);
        }
        try {
          let ctx = this;
          let data = {
            orderId: this.getOrderIdFromRoute,
            pin: (this.sigHasSigned || this.fileUploadedBoolean) ? this.pin : ''
          }
          await ctx.saveReturnReplacementReceiptAcknowledgment(data);
          await ctx.getReturnReplacementReceiptAcknowledgmentStatus(ctx.getOrderIdFromRoute);
          await ctx.loaded();
          ctx.$toast.success("Return Replacement Module signature saved successfully");
          this.$loaderApp.completeRequest();
        } catch (err) {
          this.$toast.error(errorMessage);
          await ctx.showReturnReplacementErrors(err);
          this.$loaderApp.completeRequest();

        }

      } else {
        this.$toast.error("Please fill the form required fields.");
        this.$loaderApp.completeRequest();
      }
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
  },
  watch: {
    checkSignatureGraphicalChanged(signatureData) {
      if (this.$refs.signatureImageRef) {
        let signatureImageRef = this.$refs.signatureImageRef;
        signatureImageRef.innerHTML = "";

        Util.getSignatureImageFromDataString(signatureData)
          .then((result) => {

            let image = result;
            signatureImageRef.appendChild(image);
          })
          .catch((err) => {
            console.log(err.stack); //not handelled
          });
      }
    },
    'returnReplacementReceiptAcknowledgment.returnOrganizationId': function (newVal, oldVal) {
      if (this.returnReplacementReceiptAcknowledgment && this.returnReplacementReceiptAcknowledgment.organizations.length > 0 && this.returnReplacementReceiptAcknowledgment.organizations[0].countryName != "United States") {
        this.USCountryId = false
      }
      else {
        this.getCountryId()
      }
    },
    // 'returnReplacementReceiptAcknowledgment.notifyFinance': function (newVal, oldVal) {
    //   console.log(newVal, oldVal);
    // },
    // 'returnReplacementReceiptAcknowledgment.returnDateRequested': function (newVal, oldVal) {
    //   console.log(newVal, oldVal);
    // }
  },
};
</script>

<style scopped>
.row {
  margin-right: 0px!important;
  margin-left: 0px!important;
}
</style>
